import {request} from '@/utils/request'

const baseUrl = '/hwgk'

// 获取产品列表
export const getProductListReq = (query) => request(`${baseUrl}/product/api/getProductList`, query, null, 'post')
export const getProductDetailReq = (query) => request(`${baseUrl}/product/api/getProductDetail`, query, null, 'post')
export const getSurveyDetailReq = (query) => request(`${baseUrl}/survey/api/getSurveyDetail`, query, null, 'post')
export const answerReq = (query) => request(`${baseUrl}/survey/api/answer`, query, null, 'post')
export const getServiceListReq = (query) => request(`${baseUrl}/survey/api/getSurveyList`, query, null, 'post')
// 报表
export const exportReportReq = (query) => request(`${baseUrl}/report/api/report`, query, { responseType: 'blob' }, 'post')
// 报表详情
export const getAnswerListReq = (query) => request(`${baseUrl}/report/api/reportList`, query, null, 'post')

export const getUserByCode = (query) => request(`${baseUrl}/WeChat/getUserByCode`, query, null, 'post')
export const getIP = (query) => request(`${baseUrl}/ip/get-ip`, query, null, 'get')

export const getWxSignatureReq = (query) => request(`${baseUrl}/WeChat/getSign`, query, null, 'post')
export const getDictDataReq = (query) => request(`${baseUrl}/dict/api/selectDictByType`, query, null, 'post')

export const resolueAnsReq = (query) => request(`${baseUrl}/survey/api/resolveAns`, query, null, 'post')
